import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'

import { useTagEditAction, useTagRemoveAction } from './actions'

export const useTagsActionsList = item => {
  const { t } = useTranslation('common')

  const edit = useTagEditAction(item)
  const remove = useTagRemoveAction(item)

  return [
    ...appendIf(edit.hasPermission, {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: edit.click
    }),

    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      icon: 'BsTrash',
      color: COLORS.lightRed,
      onClick: remove.click
    })
  ]
}
